import { useState, useEffect } from "react";
import FormattedTabs from "../../../components/generic/formattedTabs";
import { backendGetRequest } from "../../../helpers/callBackend";
import CustomTagsHierarchy from "./customTagsHierarchy";
import CustomTagsRules from "./customTagsRules";
import OuterBox from "../../../components/generic/arpariBoxes/OuterBox";


const CustomTags = () => {
    const [flattenedTags, setFlattenedTags] = useState([]);
    const [groups, setGroups] = useState([]);
    const [groupsPageCountExpected, setGroupsPageCountExpected] = useState(0);
    const [groupsPageCountReceived, setGroupsPageCountReceived] = useState(-1);
    const [flattenedTagsPageCountExpected, setFlattenedTagsPageCountExpected] = useState(0);
    const [flattenedTagsPageCountReceived, setFlattenedTagsPageCountReceived] = useState(-1);
    const [flattenedTagsLoading, setFlattenedTagsLoading] = useState();
    const [groupsLoading, setGroupsLoading] = useState(true);
    const TXN_TAG = 2;

    useEffect(() => {
        setFlattenedTagsLoading(flattenedTagsPageCountExpected > flattenedTagsPageCountReceived);
    }, [flattenedTagsPageCountExpected, flattenedTagsPageCountReceived]);

    const addCustomTag = (newTag) => {
        setFlattenedTags(prevTags => [...prevTags, newTag]);
    };

    const deleteCustomTag = (deletedTagId) => {
        setFlattenedTags(prevTags => prevTags.filter(tag => tag?.id !== deletedTagId));
    };

    const editCustomTag = (editedTag) => {
        setFlattenedTags(prevTags =>
            prevTags.map(tag => (tag?.id === editedTag?.id ? editedTag : tag))
        );
    };


    useEffect(() => {
        backendGetRequest("/api/generic-tag/group/", { params: { page_index: 0, group_type: TXN_TAG } })
            .then((res) => {
                setGroupsPageCountExpected(res?.data?.total_pages);
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    backendGetRequest("api/generic-tag/group/", { params: { page_index: i, group_type: TXN_TAG } })
                        .then((res) => {
                            const generic_groups = res?.data?.generic_groups;
                            setGroups(prevState => [...prevState, ...generic_groups]);
                            setGroupsPageCountReceived(prevState => prevState + 1);
                        })
                        .catch(() => {
                            setGroupsPageCountReceived(prevState => prevState - 1);
                        })
                }
            });
    }, []);

    useEffect(() => {
        backendGetRequest("/api/generic-tag/", { params: { page_index: 0, group_type: TXN_TAG } })
            .then((res) => {
                setFlattenedTagsPageCountExpected(res?.data?.total_pages);
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    backendGetRequest("api/generic-tag/", { params: { page_index: i, group_type: TXN_TAG } })
                        .then((res) => {
                            const generic_tags = res?.data?.generic_tags;
                            setFlattenedTags(prevState => [...prevState, ...generic_tags]);
                            setFlattenedTagsPageCountReceived(prevState => prevState + 1);
                        })
                        .catch(() => {
                            setFlattenedTagsPageCountReceived(prevState => prevState - 1);
                        })
                }
            });
    }, []);

    return (
        <OuterBox>
            <FormattedTabs
                defaultActiveKey={0}
                tabPanes={[
                    {
                        "title": "Rules",
                        "key": 0,
                        "body": <CustomTagsRules
                            flattenedTags={flattenedTags}
                        />
                    },
                    {
                        "title": "Tags",
                        "key": 1,
                        "body": <CustomTagsHierarchy
                            title="Custom Tags"
                            group_type={TXN_TAG}
                            flattenedTagsLoading={flattenedTagsLoading}
                            flattenedTags={flattenedTags}
                            groupsLoading={groupsLoading}
                            groups={groups}
                            addCustomTag={addCustomTag}
                            deleteCustomTag={deleteCustomTag}
                            editCustomTag={editCustomTag}
                        />
                    }
                ]}
            />

        </OuterBox>
    );
};

export default CustomTags;
